var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsWithDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 38C29.1 38 30 37.1 30 36H26C26 37.1 26.9 38 28 38ZM34 32V27C34 23.93 32.37 21.36 29.5 20.68V20C29.5 19.17 28.83 18.5 28 18.5C27.17 18.5 26.5 19.17 26.5 20V20.68C23.64 21.36 22 23.92 22 27V32L20 34V35H36V34L34 32ZM32 33H24V27C24 24.52 25.51 22.5 28 22.5C30.49 22.5 32 24.52 32 27V33Z",
    fill: "#6B7280"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 20,
    r: 3,
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsWithDot);
export default __webpack_public_path__ + "static/media/notifications-with-dot.86bdf178091baa7bda037242a8c0fd39.svg";
export { ForwardRef as ReactComponent };